import { RefreshCw } from 'lucide-react'
import { clsx } from 'clsx'
import { useLayoutVariant } from '../../hooks/useLayoutVariant'

export default function LoadingState({ 
  message = 'Cargando...',
  size = 'md'
}) {
  const { isAdminAppUI } = useLayoutVariant()
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  return (
    <div className="flex items-center justify-center py-12">
      <div className="text-center">
        <RefreshCw className={clsx(
          'animate-spin mx-auto mb-4',
          isAdminAppUI ? 'text-brand-500' : 'text-primary-600 dark:text-primary-400',
          sizeClasses[size]
        )} />
        <p className={clsx('text-sm', isAdminAppUI ? 'text-gray-400' : 'text-gray-600 dark:text-gray-400')}>
          {message}
        </p>
      </div>
    </div>
  )
}

